
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachMatchesCategoriesListFormRemove} from "@/models/app/coach/matches/categories/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "matchCategory",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachMatchesCategoriesListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  matchCategory: AppCoachMatchesCategoriesListFormRemove = new AppCoachMatchesCategoriesListFormRemove();

  formData: AppCoachMatchesCategoriesListFormRemove = new AppCoachMatchesCategoriesListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/match-category/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getMatchCategories');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.matchCategory;
  }

  resetFormData(): void {
    this.formData = new AppCoachMatchesCategoriesListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
